import $ from 'jquery';
import {onScroll} from "../utils/window";

export default function footerSection() {
	const FOOTER = $('.footer');
	const BUTTON = $('.request-info');
	let lastScrollTop = 0;

	onScroll(function (e) {
		if (e && e.target) {
			let st = $(e.target).scrollTop();
			let footerOffset = FOOTER.offset().top;

			if (st > 100 && (st + $(window).height()) < footerOffset) {
				BUTTON.removeClass('-hidden');
			} else {
				BUTTON.addClass('-hidden');
			}

			lastScrollTop = st;
		}
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/footer.js